export function getBearerToken() {
  const tokenData = JSON.parse(localStorage.getItem("sb-auth-token") || "{}");
  return tokenData.access_token || null;
}

export const getUserId = () => {
  const tokenData = JSON.parse(localStorage.getItem("sb-auth-token") || "{}");
  return tokenData?.user?.id || null;
};
